import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {black, onyx, onyxLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {
    paddingHorizontal: indent,
    paddingTop: indent * 0.8,
    paddingBottom: indent * 0.5,
    paddingRight: indent * 3,
    overflow: 'visible' as const,
  },
  text: {
    color: onyxLight,
  },
  columns: {
    flexDirection: 'row' as const,
    alignItems: 'flex-start',
    minWidth: 0,
    overflow: 'visible' as const,
  },
  columnsWrapped: {
    flexWrap: 'wrap' as const,
  },
  textColumn: {
    flex: 1,
    paddingRight: 10,
  },
  rankIconColumn: {
    width: 64,
    flexShrink: 0,
    paddingLeft: 0,
    marginLeft: 0,
    marginRight: 0,
    alignItems: 'flex-end',
    shadowColor: onyx,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 3,
  },
  rankIconColumnWrapped: {
    marginTop: 8,
    marginRight: 0,
    width: 64,
    alignItems: 'flex-end',
  },
  rankIconShieldWrapped: {
    marginTop: 0,
  },
  rankIconGlyphWrapped: {
    marginTop: 0,
  },
  leadIn: {
    marginBottom: 6,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  leadInText: {
    color: black,
    fontSize: 11,
    letterSpacing: 0.5,
    ...getFontFamily('bold'),
    textTransform: 'uppercase',
  },
  progressDescription: {
    color: black,
    ...getFontFamily('bold'),
    flex: 1,
    minWidth: 0,
    flexShrink: 1,
    paddingRight: 12,
  },
  showDetail: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
  },
  showDetailArrow: {
    color: onyxLight,
    fontSize: 18,
    alignSelf: 'flex-end',
    marginLeft: 6,
  },
});
